import React  from 'react';
import style from './fileviewer.module.scss';

const FileViewer = ({ filesList, onSelect }) => {
  return (
    <div className={style.container}>
      {filesList?.map((file, index) => (
        <div key={file.src} className={style.item}>
          <input type='checkbox' onClick={() => onSelect(index)} />
          <div className={style.checkbox}>
            <img src={'/images/export.svg'} alt='' />
          </div>
          <a href={file.src}>{file.storedFileName}</a>
        </div>
      ))}
    </div>
  );
};

export default FileViewer;
